import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0.1, testId }) => (
  <h1 className={className} data-testid={testId}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.06em]">
        <motion.span className="block" initial={{ y: "105%" }} animate={{ y: "0%" }}
          transition={{ duration: 1, ease: EASE, delay: delay + i * 0.14 }}>
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`text-xs font-extrabold uppercase tracking-[0.14em] text-brand ${className}`}>{children}</p>
);

export const SectionHead = ({ eyebrow, title, text, action }) => (
  <Reveal className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
    <div className="max-w-2xl">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="mt-2 font-display text-2xl font-bold text-ink sm:text-3xl">{title}</h2>
      {text && <p className="mt-2 text-sm text-slate-600 sm:text-base">{text}</p>}
    </div>
    {action}
  </Reveal>
);
